import { injectable } from "inversify";
import * as React from "react";
import { LoaderService } from "../../services";
import { ServiceBase } from "../../services/ServiceBase";
import { ElementLoader } from "../components/ElementLoader";
import { getDefaultPageLoaderOptions, PageLoader } from "../components/PageLoader";
import { ReactDOMProxy } from "../ReactDOMProxy";

/**
 * MUI loader component service. Displays animated loader components at a page or element level.
 */
@injectable()
export class MaterialLoaderService extends ServiceBase implements LoaderService {

	private pageLoader = getDefaultPageLoaderOptions();

	/**
	 * Initialises a new instance of the MaterialLoaderService class.
	 */
    constructor() {

		super();

		// add page loader element and render the component, so it is ready to be used on demand
        let pageLoaderContainer = document.getElementById("page-loader");

        if (!pageLoaderContainer) {

            pageLoaderContainer = document.createElement("div");
            pageLoaderContainer.id = "page-loader";
            document.body.appendChild(pageLoaderContainer);
        }

        if (pageLoaderContainer) {

			ReactDOMProxy.renderStyled(
				<PageLoader options={this.pageLoader} />,
                pageLoaderContainer
            );
        }

	}

	/**
	 * @inheritdoc
	 */
	public showPageLoader(): void {

		this.pageLoader.show();
	}

	/**
	 * @inheritdoc
	 */
	public hidePageLoader(): void {

		this.pageLoader.hide();
	}

	/**
	 * @inheritdoc
	 */
    public render(target: Element): void {

        if (target) {
				
            let elementLoaderWrapper = target.querySelector(".element-loader-wrapper");

			if (!elementLoaderWrapper) {
				elementLoaderWrapper = document.createElement("div");
                elementLoaderWrapper.className = "element-loader-wrapper";
                target.appendChild(elementLoaderWrapper);
			}

			ReactDOMProxy.renderStyled(
				<ElementLoader />,
                elementLoaderWrapper
			);
        }
	}

	/**
	 * @inheritdoc
	 */
	public remove(target: Element): void {

		const loaderWrapper = target.querySelector(".element-loader-wrapper");

		if (loaderWrapper) {

			ReactDOMProxy.unmount(loaderWrapper);
			loaderWrapper.remove();
		}
	}
}